import helpers from '../helpers';

function init() {
	helpers.$header = $('.header');

	$('.header__share__toggle').on('click', (e) => {
		e.preventDefault();
		$('.header__share').toggleClass('is-show');
	});
}

function destroy() {
}

export default {
	init,
	destroy,
};
